import Vue from 'vue'
import Vuex from 'vuex'
import CF from '../static/config.json'

Vue.use(Vuex)

const state = {
  config: {},
  public_token: CF.public_token,
  is_loading: false,
  api_url: CF.api_url,
  ui_url: CF.ui_url,
  screen_height: 0,
  screen_width: 0,
  footer_show: true,
  header_show: true
}

const store = new Vuex.Store({
  state
})

export default store



// WEBPACK FOOTER //
// ./src/vuex.js